import type { Change, Inline } from '@gitbook/slate';
import { Icon } from '@gitbook/spine-icons';
import { renderIcon, TextField, TextInput, type TextInputProps } from '@gitbook/spine-react';
import { assert } from '@gitbook/util-ts';

/**
 * Get the text of an inline node.
 */
export function getInlineText(node: Inline) {
    return node.getText();
}

/**
 * Use a change to to set an inline text if necessary.
 */
export function setInlineText(change: Change, node: Inline, text: string) {
    if (node.isVoid) {
        return change;
    }

    if (node.getText() !== text) {
        const firstText = node.getTexts().first();
        assert(firstText);
        change.replaceTextByKey(firstText.key, 0, firstText.getText().length, text);
    }

    return change;
}

/**
 * Inline text field, ready to be used in a form.
 */
export function InlineTextField(props: { name: string } & Pick<TextInputProps, 'autoFocus'>) {
    const { name, autoFocus } = props;
    return (
        <TextField name={name} required>
            <TextInput
                prefix={renderIcon(Icon.AlignTextLeft, { className: 'text-muted' })}
                autoFocus={autoFocus}
            />
        </TextField>
    );
}
